"use client";

// Price history for one laptop config, fetched once and shared by the chart and
// the buy drawer.
//
// Client-side rather than folded into the page's own data for two reasons: the
// recommendations response already carries many laptops and must not also carry
// a year of points for each, and the /spec route is cached for an hour, which is
// the one thing a price chart should not be.
//
// It fetches the full history once and the component slices it per range, so
// switching between 3 months and All is instant and costs no request.
import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { API_BASE } from "@/lib/api";
import type { PriceHistoryResponse } from "@/lib/types";
export function usePriceHistory(country, series, config, enabled) {
  const $ = _c(9);
  const key = `${country}/${series}/${config}`;
  const [settled, setSettled] = useState(null);
  let t0;
  let t1;
  if ($[0] !== config || $[1] !== country || $[2] !== enabled || $[3] !== series) {
    t0 = () => {
      if (!enabled || !country || !series || !config) {
        return;
      }
      const controller = new AbortController();
      fetch(`${API_BASE}/recommend/laptop/${encodeURIComponent(country)}/` + `${encodeURIComponent(series)}/${encodeURIComponent(config)}/price-history`, {
        signal: controller.signal
      }).then(_temp).then(history => setSettled({
        key: `${country}/${series}/${config}`,
        history
      })).catch(e => {
        if (e?.name === "AbortError") {
          return;
        }
        setSettled({
          key: `${country}/${series}/${config}`,
          history: null
        });
      });
      return () => controller.abort();
    };
    t1 = [country, series, config, enabled];
    $[0] = config;
    $[1] = country;
    $[2] = enabled;
    $[3] = series;
    $[4] = t0;
    $[5] = t1;
  } else {
    t0 = $[4];
    t1 = $[5];
  }
  useEffect(t0, t1);
  const t2 = settled?.key === key ? settled.history : null;
  const t3 = enabled && settled?.key !== key;
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = {
      history: t2,
      loading: t3
    };
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp(res) {
  return res.ok ? res.json() : null;
}